<template>
  <div class="afdc-fuel-filters-box">
    <div class="afdc-form-group afdc-row">
      <div class="afdc-col-sm-12">
        <div class="afdc-custom-control afdc-custom-checkbox">
          <input type="checkbox" v-model="queryHydrogenNonRetail" class="afdc-custom-control-input" aria-describedby="afdc-analyze-hydrogen-non-retail-help" id="afdc-analyze-hydrogen-non-retail">
          <label class="afdc-custom-control-label" for="afdc-analyze-hydrogen-non-retail">{{ $t('Include non-retail stations') }}</label>
        </div>
        <small class="afdc-form-text" id="afdc-analyze-hydrogen-non-retail-help">{{ $t('These stations are only available to a certain subset of customers.') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  computed: {
    queryHydrogenNonRetail: syncInputRouteQuery('hy_nonretail'),
  },
};
</script>

<style lang="scss">
</style>
